import * as React from 'react';

export interface ButtonPostbackProps {
    children: React.ReactNode;
    onClick: Function;
}

const ButtonPostback = ({
    children,
    variant,
    onClick,
    ...restProps
}: ButtonPostbackProps & any) => {
    const variantClass = variant ? `rw-reply-${variant}` : '';

    return (
        <button
            type="button"
            className={`rw-reply ${variantClass} rw-button-postback`}
            onClick={(e) => {
                e.stopPropagation();
                onClick && onClick(e);
            }}
            onMouseUp={(e) => e.stopPropagation()}
            {...restProps}
        >
            {children}
        </button>
    );
};

export default ButtonPostback;
